import Joi from 'joi';

export const kpiQuerySchema = Joi.object({
  from: Joi.string().isoDate().optional(),
  to: Joi.string().isoDate().optional(),
  search: Joi.string().allow('').optional(),
  platform: Joi.string().optional(),
  project: Joi.string().optional(),
});

export const getKpi = {
  query: kpiQuerySchema,
};
